import Link from 'next/link';
import { useRouter } from 'next/router';

import qs from 'qs';

import type CapacityType from '../../types/CapacityType';

import styles from './CapacityFilter.module.scss';

interface Props {
  capacities: Array<CapacityType>;
  selectedCapacity: CapacityType | null;
  urlPrefix?: string;
}

const CapacityFilter: React.FC<Props> = ({
  capacities,
  selectedCapacity,
  urlPrefix = '/katalog',
}) => {
  const router = useRouter();

  return (
    <div className={styles.capacityFilter}>
      <h3>Pojemność</h3>

      <ul>
        {capacities.map((capacity) => (
          <li
            key={capacity.id}
            className={
              selectedCapacity?.id == capacity.id
                ? styles.selectedOption
                : undefined
            }
          >
            <Link
              href={
                selectedCapacity?.id == capacity.id
                  ? urlPrefix
                  : `${urlPrefix}?${qs.stringify({
                      size: capacity.id,
                      query: router.query.query,
                    })}`
              }
            >
              <a>{capacity.name}</a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default CapacityFilter;
